// src/services/sociosApi.js
import { authFetch } from "./auth";

// Helper estándar para parsear JSON y propagar mensajes de error
async function fetchJson(url, init = {}) {
  const res = await authFetch(url, {
    cache: "no-store",
    ...init,
    headers: {
      Accept: "application/json",
      ...(init.headers || {}),
    },
  });

  if (!res.ok) {
    let detail = "";
    try {
      const ct = res.headers.get("content-type") || "";
      if (ct.includes("application/json")) {
        const body = await res.json();
        detail = body?.detail || body?.message || JSON.stringify(body);
      } else {
        detail = await res.text();
      }
    } catch {
      /* noop */
    }
    const reason = detail ? ` (${detail})` : "";
    throw new Error(`${res.status} ${res.statusText}${reason}`);
  }

  if (res.status === 204) return null;
  return res.json();
}

/* ===================== Listados / detalle ===================== */

export async function listarSocios() {
  return fetchJson("/api/socios/");
}

export async function obtenerSocio(id) {
  return fetchJson(`/api/socios/${id}`);
}

export async function obtenerResumen(id) {
  return fetchJson(`/api/socios/${id}/resumen`);
}

export async function listarDocumentosSocio(id) {
  return fetchJson(`/api/socios/${id}/documentos`);
}

/** 🔹 Categorías (raíz) del socio – GET /api/socios/:id/categorias */
export async function listarCategoriasSocio(id) {
  const res = await authFetch(`/api/socios/${id}/categorias`, {
    cache: "no-store",
    headers: { Accept: "application/json" },
  });
  if (!res.ok) {
    const txt = await res.text().catch(() => "");
    throw new Error(`Error listando categorías (${res.status}) ${txt}`);
  }
  return res.json(); // { categorias: [...] }
}

/* =================== Acciones admin sobre socio =================== */

export async function crearSocio(payload) {
  // payload: { nombre, apellidos, dni, ... }
  return fetchJson("/api/socios/", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}

export async function actualizarSocio(id, payload) {
  return fetchJson(`/api/socios/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}

export async function borrarSocio(id) {
  return fetchJson(`/api/socios/${id}`, { method: "DELETE" });
}

/* ===================== Batch alertas (GET) ===================== */

export async function batchAlertas() {
  try {
    const list = await fetchJson("/api/socios/batch/alertas");
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
}

/* ========================= Alta wizard ========================= */

// POST /api/socios/alta/precheck
export async function precheckAlta(flags) {
  return fetchJson("/api/socios/alta/precheck", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(flags || {}),
  });
}

// POST /api/socios/alta/v2
export async function altaSocioV2({ socio, flags, carpetas } = {}) {
  return fetchJson("/api/socios/alta/v2", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      socio: socio || {},
      flags: flags || {},
      ...(Array.isArray(carpetas) && carpetas.length ? { carpetas } : {}),
    }),
  });
}

/* ===================== Checklist & Flags ===================== */

// Checklist “vivo” (backend)
export async function obtenerChecklistSocio(id, init = {}) {
  return fetchJson(`/api/socios/${id}/checklist`, init); // acepta {signal}
}

// Flags (nombres nuevos)
export async function getSocioFlags(id) {
  return fetchJson(`/api/socios/${id}/flags`);
}
export async function setSocioFlags(id, flags) {
  return fetchJson(`/api/socios/${id}/flags`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(flags || {}),
  });
}

// 🔁 Alias compatibles (por si el proyecto los usa en otros puntos)
export async function obtenerFlagsSocio(id) {
  return getSocioFlags(id);
}
export async function guardarFlagsSocio(id, flags) {
  return setSocioFlags(id, flags);
}
